module.exports = __webpack_public_path__ + "img/xlm-the-asset.767ef6f0.png";